import { get } from 'typescripts/services/utils/lodash.service';
const i18nMissing = 'Missing translation';

/**
 * Get a i18n translation
 * @param  {string} path Path to the translation key
 * @return {string}      Returns a translation string
 */
const i18n = (path, ...i18nVars) => {
  const error = `${i18nMissing}: ${path}`;
  let locale = get(window.i18n, path, error);

  // If the passed path points to an object, we can assume it's for pluralization
  // (with the zero / one / other keys)
  if (typeof locale === 'object') {
    const count = i18nVars;
    const pluralMap = {
      0: 'zero',
      1: 'one',
    };

    locale = get(locale, get(pluralMap, count, 'other'), error);
  }

  // If we have some passed vars, replace them in the locale string
  if (i18nVars.length > 0) {
    const localeRegex = /%{[^}]*}/;
    // Replace vars (%{}) from locale string
    i18nVars.forEach((i18nVar) => {
      locale = locale.replace(localeRegex, i18nVar);
    });
    return locale;
  }

  return locale;
};

export default i18n;
